/* @flow */
import { Record } from 'immutable';

export type RawSector = {
  id: number,
  label: string,
  name: string,
};

export const Sector = Record({
  id: null, // Number
  label: '',
  name: '',
});




// WEBPACK FOOTER //
// ./src/app/modules/sectors/types.js